require('react-hot-loader')
import React from 'react'
import ReactDOM from 'react-dom'
import { useRoutes } from 'hookrouter'
import { lazyLoader } from './components/shared/lazy-loader'
import './styles/index.scss'
import Modal from './components/shared/modal'
import ModalProvider from './providers/modal'
import ThemeProvider from './providers/theme'
import HomePage from './pages/home'

const LazyError = React.lazy(() => import('./pages/error'))
const routes = {
  '/': lazyLoader(HomePage),
  '/404': lazyLoader(LazyError)
}

const App = () => {
  const routeResult = useRoutes(routes)
  const Error = routes['/404']
  return (
    <ThemeProvider>
      <ModalProvider>
        {routeResult || <Error />}
        <Modal />
      </ModalProvider>
    </ThemeProvider>
  )
}
if (module.hot) {
  module.hot.accept()
}

var mountNode = document.getElementById('app')
ReactDOM.render(<App />, mountNode)
